// import { PROVIDER_REGISTRATION_BASE } from '~/utils/constants';
import { paths } from '~/routing';
import { logger } from '~/utils/logger';

export const RegistrationLog = logger.child('RegistrationLog');

const BASE = paths.register.provider;

// Stable ids for the <form> elements on each registration page. Pages render
// the submit button in the page-level action bar (outside the form) and
// associate it via `<Button form={...} type="submit" />`.
export const WELCOME_FORM_ID = 'registration-welcome-form';
export const TYPE_CATEGORY_FORM_ID = 'registration-type-category-form';

export const PAGES = {
  WELCOME: BASE + '/welcome',
  TYPE_CATEGORY_NPI: BASE + '/type-category-npi',
  NPI_LOADING: BASE + '/npi-loading',
  CV_UPLOAD: BASE + '/cv-upload',
  REGISTRATION_COMPLETE: BASE + '/registration-complete',
};

export const emptyTypeAndCategoryForm = {
  category: { label: '', value: 0 },
  type: { label: '', value: 0 },
  firstName: '',
  lastName: '',
  npi: undefined,
};

export const initialTypeAndCategoryForm = {
  category: undefined,
  type: undefined,
  firstName: '',
  lastName: '',
  npi: undefined,
};

export const emptyCvUploadState = {
  dragging: false,
  uploading: false,
  uploaded: false,
  errorMsg: undefined,
  name: undefined,
  type: undefined,
  size: undefined,
};
